<template>
  <b-section-loader :loading="$loading.isLoading('init')">
    <div>
      <div
        class="d-flex align-center justify-space-between flex-wrap ga-2 mb-4">
        <v-btn border color="white" @click="backToRegistry">
          <v-icon icon="mdi-chevron-left"></v-icon>
          <span class="font-weight-medium">Назад до реєстру</span>
        </v-btn>

        <div class="d-flex align-center ga-2 flex-wrap">
          <v-btn
            :disabled="
              (!canEditIncident && !canEditAttachments) ||
              !incidentCredentials.$hasChanges
            "
            border
            color="white"
            @click="cancelChanges">
            <span class="font-weight-medium">Скасувати зміни</span>
          </v-btn>
          <v-btn
            :disabled="
              (!canEditIncident && !canEditAttachments) ||
              !incidentCredentials.$hasChanges
            "
            :loading="$loading.isLoading('updateIncident')"
            border
            @click="updateIncident">
            <span class="font-weight-medium">Зберегти</span>
          </v-btn>
        </div>
      </div>

      <v-card>
        <incident-header></incident-header>
        <incident-tabs></incident-tabs>
        <router-view></router-view>
      </v-card>
    </div>
  </b-section-loader>
</template>

<script lang="ts" setup>
import { BSectionLoader } from 'best-modules/components'
import { initIncident } from './Incident'
import IncidentHeader from './components/IncidentHeader.vue'
import IncidentTabs from './components/IncidentTabs.vue'

defineOptions({
  name: 'IncidentSingle',
})

const {
  backToRegistry,
  canEditAttachments,
  canEditIncident,
  cancelChanges,
  incidentCredentials,
  updateIncident,
} = initIncident()
</script>
